import { jsx as _jsx } from "react/jsx-runtime";
import { useSearchParams } from 'react-router-dom';
import { CycleBoard } from '@/widgets/cycle-board';
import { EngagementBoard } from '@/widgets/engagement-board';
export function EngagementsPage() {
    const [searchParams] = useSearchParams();
    const legacyTrajectory = searchParams.get('trajectory');
    if (legacyTrajectory) {
        return _jsx(EngagementBoard, {});
    }
    return _jsx(CycleBoard, {});
}
